<template>
    <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 py-3 items-center">
      <div class="bg-white w-full rounded-lg shadow pb-2">
        <div id="noShow" class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
          <div class="flex w-full">
             <button
              :class="$colors.primary"
              class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
              @click="RouterBack()"
            >
              <i class="material-icons">chevron_left</i>
            </button>
  
            <div class="text-xl font-bold text-green-700">{{$t('Salarie details')}}</div>
          </div>
        </div>


        <!--//-->
        <div :id="`detailP${item && item._id?'-'+item._id:''}`" class="card-body">
            <h4 class="payslip-title">FICHE DE SALAIRE DU MOIS DE {{ $moment(formData.date).locale('fr').format('MMMM') }} {{ $moment(formData.date).year() }}</h4>
            <div class="row">
                <div class="col-sm-6 m-b-20">
                    <ul class="list-unstyled">
                        <li><h5 class="mb-0"><strong>{{ formData.user.fullName }} <span v-if="formData.user.username">({{ formData.user.username }})</span></strong></h5></li>
                        <li><span>{{ formData.user.type }}</span></li>
                    </ul>
                   <!-- <img src="https://storeino-files.b-cdn.net/CODINAFRICA.png" class="inv-logo" alt="Logo"> -->
                </div>
                <div class="col-sm-6 m-b-20">
                    <div class="invoice-details">
                        <h3 class="text-uppercase">Fiche de paie #{{ formData.id }}</h3>
                        <ul class="list-unstyled">
                            <li>Mois de salaire: <span>{{ $moment(formData.date).locale('fr').format('MMMM') }} , {{ $moment(formData.date).year() }}</span></li>
                            <li class="no-display mt-2"><button class="btn btn-white" @click="generateReport"><svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icon-tabler-printer inline-block"><rect x="0" y="0" width="24" height="24" stroke="none"></rect><path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"></path><path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"></path><rect x="7" y="13" width="10" height="8" rx="2"></rect></svg> Print</button></li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-lg-12 m-b-20">
                <ul class="list-unstyled">
                    <li><h5 class="mb-0"><strong>{{ formData.user.fullName }} <span v-if="formData.user.username">({{ formData.user.username }})</span></strong></h5></li>
                    <li><span>{{ formData.user.type }}</span></li>
                </ul>
                </div>
            </div> -->
            <div class="row">
            <div class="col-sm-6">
            <div>
            <h4 class="m-b-10"><strong>Gains</strong></h4>
            <table class="table table-bordered">
            <tbody>
            <tr>
              <td><strong>Salaire de base</strong> <span class="float-end">{{ formData.salary?formData.salary.toFixed():0 }} <sup>{{ idWharhouse.currency }}</sup></span> <small>({{formData.daysPresence}} Jour(s))</small></td>
            </tr>

            <tr v-for="(item, index) in  formData.fees.filter(item => !item.is_deduction)" :key="'Prime-'+index">
              <td><strong>{{ item.name }}</strong> <span class="float-end">{{ item.amount }} <sup>{{ idWharhouse.currency }}</sup></span></td>
            </tr>

            <tr v-if="formData.fees.filter(item => !item.is_deduction).length>0">
               <td><strong>Total des gains</strong> <span class="float-end"><strong>{{ formData.fees.filter(item => !item.is_deduction).map(item => item.amount).reduce((prev, next) => prev + next) }}</strong>  <sup>{{ idWharhouse.currency }}</sup></span></td>
            </tr>

            </tbody>
            </table>
            </div>
            </div>
            <div class="col-sm-6">
            <div>
            <h4 class="m-b-10"><strong>Déductions</strong></h4>
            <table class="table table-bordered">
                <tbody>
                    
                    <tr>
                       <td>
                        <strong>Absence (<small>{{ formData.daysAbsent }} Jour(s)</small>)</strong> 
                          <div v-if="absencesDays.length>0" v-for="(abs, ind) in absencesDays" :key="'abs'+ind" style="display: block; padding-left: 10px;text-transform: capitalize;">
                             <span>{{ abs.date }} ({{ abs.datas.map(e => e.horaire).sort((a, b) => a > b ? -1 : (a > b ? 1 : 0)).toString() }})</span>
                          </div>
                       </td>
                    </tr>
                    <tr v-for="(item, index) in formData.fees.filter(item => item.is_deduction)" :key="'Deductions'+index">
                        <td><strong>{{ item.name }}</strong> <span class="float-end">{{ item.amount }} <sup>{{ idWharhouse.currency }}</sup></span></td>
                    </tr>
                
                    <tr v-if="formData.fees.filter(item => item.is_deduction).length>0">
                    <td><strong>Le total des déductions</strong> <span class="float-end"><strong>{{ parseFloat(formData.absentAmount) + parseFloat(formData.fees.filter(item => item.is_deduction).map(item => item.amount).reduce((prev, next) => prev + next)) }}</strong>  <sup>{{ idWharhouse.currency }}</sup></span></td>
                    </tr>

                </tbody>
            </table>
            </div>
            </div>
            <div class="col-sm-12">
              <p><strong>Salaire Net: {{ checkAmount(formData) }} <sup>{{ idWharhouse.currency }}</sup></strong> {{ `${translateToFrench(checkAmount(formData))?'('+translateToFrench(checkAmount(formData))+'.)':''}` }}</p>
            </div>
            </div>
        </div>
        <!-- //-->

      </div>
  
    </div>
  </template>
  
  
  
  
  <script>
  import image from "@/assets/CODINAFRICA.png";
  
  //or directly in browser
  export default {
    props: {
       currentUser: { type: Object},
       idWharhouse: { type: Object},
       item: {type: Object,default: function () {return {user:{},fees:[]}} },
     },
    data() {
      return {
        formData: {
            user: {},
            fees:[]
        },
        image:image,
        fullPage: false,
        loading:false,
        content: [],
        dataChange:{index:null},
        absencesDays:[]
      };
    },
    watch: {
       
    },
    async mounted() {
        await this.dataToEdit(this.item); 
    },
    methods: {
        RouterBack: function() {
           this.$router.back();
        },

        checkAmount(sal){
            let data=0;
            if(sal.fees.length>0){
                data= sal.fees.reduce((total, fees) => {
                    if (fees.is_deduction) {
                        return parseFloat(total) - parseFloat(fees.amount);
                    } else {
                        return parseFloat(total) + parseFloat(fees.amount);
                    }
                }, 0);
            }
            
            if(isNaN(data)) data=0;
            var total=(parseFloat(sal.salary) - parseFloat(sal.absentAmount)) + data;
            return total?total.toFixed():0;
        },

        getAccess(modelToCheck, accessToCheck) {
                if(this.currentUser && this.currentUser.type){
                const permissions = this.currentUser.role.permissions;
                for (let i in permissions) {
                    let model = permissions[i]["model"];
                    let access = permissions[i]["access"];
        
                    if (model == modelToCheck) {
                    return access[accessToCheck];
                    }
                }
                }else return false;
        },

        getElementInArray(data,value){
            var result  = data.filter(function(o){
                let whar=o.warehouse;
                if(o.warehouse._id) whar=o.warehouse._id;
                return whar == value.toString();
            } );
            return result? result[0] : null; // or undefined
        },

        async generateReport() {
        
                var mywindow = window.open('', 'PRINT', 'height=400,width=600');
                mywindow.document.write(`<html lang="en"><head><meta charset="utf-8"><title>${this.formData.user.fullName}</title>`);
                mywindow.document.write('<style type="text/css">.btn-white { background-color: #ffffff; border: 1px solid #cccccc; color: #272b41; border-radius: 0.25em; transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out; text-align: center; text-decoration: none; vertical-align: middle; font-size: 0.875em; font-weight: 400; line-height: 1.5; display: inline-block; padding: 0.25em 0.5em; } .card-body { flex: 1 1 auto; padding: 20px; } .payslip-title { text-align: center; text-decoration: underline; text-transform: uppercase; margin: 0 0 20px; } .row { --bs-gutter-x: 1.5rem; --bs-gutter-y: 0; display: flex; flex-wrap: wrap; margin-top: 0; margin-right: 1.5em; margin-left: 1.5em; } .m-b-20 { margin-bottom: 20px !important; } @media (min-width: 576px){ .col-sm-6 { flex: 0 0 auto; width: 50%; } } @media (min-width: 992px){ .col-lg-12 { flex: 0 0 auto; width: 100%; } .col-sm-6 { flex: 0 0 auto; width: 50%; } .col-sm-12 { flex: 0 0 auto; width: 100%; } } .inv-logo { height: auto; max-height: 100px; width: 35%; margin: 0 0 20px; } img { max-width: 100%; vertical-align: middle; } .mb-0 { margin-bottom: 0 !important; } .list-unstyled { padding-left: 0; list-style: none; } .invoice-details { float: right; text-align: right; } .text-uppercase { text-transform: uppercase !important; } h3 { font-weight: 500; font-size: 24px; margin-bottom: 0.5rem; } h5 { font-weight: 500; font-size: 14px; margin-bottom: 0.5rem; } h4 { font-weight: 500; font-size: 18px; margin-bottom: 0.5rem; } .table { padding: 0; background: #ffffff; caption-side: bottom; border-collapse: collapse; width: 100%; margin-bottom: 1rem; vertical-align: top; border-color: #dfe3e7; } .table>tbody { vertical-align: inherit; } .table-bordered>:not(caption)>* { border-width: 1px 0; } .table td { border: 1px solid #dee2e6; white-space: nowrap; vertical-align: middle; padding: 0.5rem; } .login-or { position: relative; color: rgb(0 0 0 / 55%);; margin-top: 10px; margin-bottom: 10px; padding-top: 10px; padding-bottom: 10px; } .hr-or { height: 2px; margin-top: 0px !important; margin-bottom: 0px !important; border: 0; border-top: 2px solid rgb(0 0 0 / 55%); } .span-or { display: block; position: absolute; left: 39%; top: -2px; background-color: #fff; width: 190px; text-align: center; font-weight: 700; } .invoice { display: flex; } .invoice-title { color: #999; font-size: 1.875rem; line-height: 2.25rem; margin-bottom: 0; font-weight: 700; text-transform: uppercase; } .invoice-des { text-align: right; margin-left: auto; } .invoice-logo{ margin-left: auto; width: 10.5rem; height: auto; display: block; vertical-align: middle; } caption { background: #cdcdcd; font-weight: bold; font-size: 1.1em; margin-left: -1px; /* Fix FF 1px issue */ } .w-40{ width: 25em; } .empty-row{ background: repeating-linear-gradient( 53deg , #bfc0c2 4%, #fcfcff 11px 6%, #ffffff 10px 7%, #9d9c9c 15px); } /* animation for vue transition tag */ dialog[open] { animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8); } dialog::backdrop { background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5)); backdrop-filter: blur(3px); } table{max-width: 100%;overflow: scroll;}.login-or { position: relative; color: rgb(0 0 0 / 55%); margin-top: 10px; margin-bottom: 10px; padding-top: 10px; padding-bottom: 10px; } .hr-or { height: 2px; margin-top: 0px !important; margin-bottom: 0px !important; border: 0; border-top: 2px solid rgb(0 0 0 / 55%); } .span-or { display: block; position: absolute; left: 47%; top: -2px; margin-left: -25px; background-color: #fff; width: 190px; text-align: center; font-weight: 700; }.text-xs { font-size: 0.75rem; }.font-semibold { font-weight: 600; }.text-center { text-align: center; } .pl-3 { padding-left: 0.75rem; }.pr-2 { padding-right: 0.5rem; } .p-1 { padding: 0.25rem; }#detailP{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";}.no-display{display: none !important;}.no-border{border: none;}.text-xs{font-size: 0.75rem;}.text-gray-600{color: #718096;}td {display: table-cell;vertical-align: inherit;}.text-green-700{color: #2f855a;}.invoice { display: flex; } .invoice-title { color: #999; font-size: 1.875rem; line-height: 2.25rem; margin-bottom: 0; font-weight: 700; text-transform: uppercase; } .invoice-des { text-align: right; margin-left: auto; } .invoice-logo{ margin-left: auto; width: 10.5rem; height: auto; display: block; vertical-align: middle; } caption { background: #cdcdcd; font-weight: bold; font-size: 1.1em; margin-left: -1px; /* Fix FF 1px issue */ } .w-40{ width: 25em; }.mb-6 { margin-bottom: 0.7rem; }.items-center{ align-items: center;} .align-items-center{ align-items: center !important; } .text-blue { color: #3182ce; } .row { display: flex; flex-wrap: wrap; } .text-sm-end { text-align: right; } .col-sm-5 { flex: 0 0 auto; width: 41.66666667%; } .text-sm-start { text-align: left; } .mb-sm-0 { margin-bottom: 0; } .mb-0 { margin-bottom: 0; } .mb-3 { margin-bottom: 1rem; } .imgg { vertical-align: inherit; width: 40px; display: inline-block; } .v-super{ vertical-align:super } .col-sm-7 { flex: 0 0 auto; width: 58.33333333%; } .h4 { font-size: 1.5rem; color: #0c2f54; } .p { line-height: 1.9; margin-top: 0; margin-bottom: 1rem; } .text-2xl { font-size: 1.5rem; } .pl-4 { padding-left: 1rem; } .border-l-2 { border-left-width: 2px !important;; border-color: #3182ce !important; } .mt-10{ margin-top: 10px; } .text-xss { font-size: 0.70rem !important; } .border-blue-600 { border-color: #3182ce; } .p-4 { padding: 1rem; } .mt-4 { margin-top: 1rem; } .tracking-wider { letter-spacing: 0.05em; } .text-gray-600 { color: #718096; } .text-left { text-align: left; } .text-blue-700 { color: #114f8f; } .px-6 { padding-left: 1.5rem; padding-right: 1.5rem; } .p-bb{ padding-bottom: 4px; } .py-3 { padding-top: 0.55rem; padding-bottom: 0.55rem; } .leading-4 { line-height: 1rem; } .border-b-2 { border-bottom-width: 2px; border-color: #e2e8f0 !important; } .border-t-2 { border-top-width: 2px; border-color: #e2e8f0 !important; } .border-gray-300 { border-color: #e2e8f0; } .bg-gray-200 { background-color: #edf2f7; } .h-auto { height: auto; } .bg-gray-100 { background-color: #f7fafc; } .border-dashed { border-style: dashed; } .border-gray-800 { border-color: #2d3748; } .text-xs { font-size: 0.55rem; } .font-semibold { font-weight: 600; } .dis-none{ display: none; } .text-gray-700 { color: #262728; } .rounded-full { border-radius: 9999px; } .border-b { border-bottom-width: 1px; border-color: #e2e8f0 !important; } .border-gray-200 { border-color: #8e9193; } tbody { display: table-row-group; vertical-align: middle; border-color: inherit; } tr { display: table-row; vertical-align: inherit; border-color: inherit; } .px-5 { padding-left: 1.10rem; padding-right: 1.10rem; } .width-40{ width: 50% !important; } .mb-3 { margin-bottom: 0.75rem; } sup { top: -0.5em; } .mt-10{ margin-bottom: 10px; } .border-b { border-bottom-width: 1px; border-color: #e2e8f0 !important; } .border-t { border-top-width: 1px; border-color: #e2e8f0 !important; } .text-xl { font-size: 1.25rem; } sub, sup { font-size: 75%; line-height: 0; position: relative; vertical-align: baseline; } .pt-4 { padding-top: 1rem; } .text-m { font-size: 18px; } .w-40 { width: 10rem; } .text-right { text-align: right; } .text-gray-900 { color: #1a202c; } .flex-1 { flex: 1 1 0%; } .py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; } .ml-auto { margin-left: auto; } .min-w-full { min-width: 100%; } .mt-5 { margin-top: 1.25rem; } table { display: table; border-collapse: collapse; box-sizing: border-box; text-indent: initial; border-spacing: 2px; border-color: grey; } .p-2 { padding: 0.5rem; } .ml-1 { margin-left: 0.25rem; } .overflow-visible{white-space: initial;}.trakingn img{width: 50%;}.mb-0{margin-bottom: 0px;}.w-1/4{width: 25%;}.w-3/4{width: 75%;}.m-0{margin:0}.pt-0{padding-top: 0px;}.mt-0{margin-top: 0px;}.py-1{padding-top: 0.25rem;padding-bottom: 0.25rem;}.px-3{padding-left: 0.75rem;padding-right: 0.75rem;}.w-2/4{width: 50%;}.mt-1{margin-top: 0.25rem;}.align-top{vertical-align: top;}p{margin:0}table{border-collapse: collapse;}table th, table td {border:1px solid #000;}.text-right{text-align:right}.flex-1{flex:1 1 0%}.w-40{width:10rem}.font-medium{font-weight:500}.py-1{padding-top:.25rem;padding-bottom:.25rem}.inline-block{display:inline-block}.mb-3{margin-bottom:.75rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.ml-auto{margin-left:auto}.border-black{border: 1px solid black;}.border{border-width:1px}.whitespace-no-wrap{white-space:nowrap}.text-center{text-align:center}.w-1/4{width: 25%}.text-left{text-align:left}.px-2{padding-left:.5rem;padding-right:.5rem}.min-w-full{min-width:100%}.mb-5{margin-bottom:1.25rem}.px-1{padding-left:.25rem;padding-right:.25rem}.mx-auto{margin-left:auto;margin-right:auto}body{font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";font-size:1em}.justify-between{justify-content:space-between}.w-full{width:100%}.block{display:block}.flex{display:flex}.uppercase{text-transform: uppercase;}.mb-2{margin-bottom: 0.5rem;}.mb-3{margin-bottom: 0.75rem;}.font-bold{font-weight: 700;}.font-semibold{font-weight:600}.text-xl{font-size: 1.25rem;line-height: 1.75rem;}.size-m{font-size: 12px;font-weight: 500;}@media print {@page {size:  auto; margin: 0mm;}}</style>');
                mywindow.document.write('</head><body style="margin:5mm;margin-top:5mm;page-break-after: avoid; page-break-before: avoid;">');
                mywindow.document.write(document.getElementById("detailP").innerHTML);
                mywindow.document.write('</body></html>');
                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10*/
                const self=this;
                setTimeout(function () {
                    mywindow.print();
                    mywindow.close();
                }, 500);
                return false;
        },   

        translateToFrench(number) {
            const frenchNumbers = {
                0: 'zéro', 1: 'un', 2: 'deux', 3: 'trois', 4: 'quatre', 5: 'cinq', 6: 'six', 7: 'sept', 8: 'huit', 9: 'neuf',
                10: 'dix', 11: 'onze', 12: 'douze', 13: 'treize', 14: 'quatorze', 15: 'quinze', 16: 'seize', 17: 'dix-sept', 18: 'dix-huit', 19: 'dix-neuf',
                20: 'vingt', 30: 'trente', 40: 'quarante', 50: 'cinquante', 60: 'soixante', 70: 'soixante-dix', 80: 'quatre-vingts', 90: 'quatre-vingt-dix'
            };

            if (number >= 0 && number < 20) {
                return frenchNumbers[number];
            } else if (number >= 20 && number < 100) {
                const tens = Math.floor(number / 10) * 10;
                const units = number % 10;
                if (units === 0) {
                    return frenchNumbers[tens];
                } else {
                    return frenchNumbers[tens] + '-' + frenchNumbers[units];
                }
            } else if (number >= 100 && number < 1000) {
                const hundreds = Math.floor(number / 100);
                const remainder = number % 100;
                if (remainder === 0) {
                    return frenchNumbers[hundreds] + ' cents';
                } else {
                    return frenchNumbers[hundreds] + ' cents ' + this.translateToFrench(remainder);
                }
            } else if (number >= 1000 && number < 1000000) {
                const thousands = Math.floor(number / 1000);
                const remainder = number % 1000;
                if (remainder === 0) {
                    return this.translateToFrench(thousands) + ' mille';
                } else if (remainder < 100) {
                    return this.translateToFrench(thousands) + ' mille ' + this.translateToFrench(remainder);
                } else {
                    return this.translateToFrench(thousands) + ' mille ' + this.translateToFrench(remainder);
                }
            } else {
                return null;
            }
        },

        async dataToEdit(dataTable=null) {
        console.log('data invoice------------',dataTable)
        if (this.$route.params.id || (dataTable && dataTable._id)) {
            if(this.$route.params.id ){
                this.loading=true;
                const {content:data} = await this.$server.get("salaries", {id: this.$route.params.id}); 
                this.loading=false;  
                this.formData = data;
            }else this.formData = dataTable;
            console.log('formData------------',this.formData)

            //check days absence
            if(this.formData._id && this.formData.daysAbsent){
                this.loading=true;
                const {content:dataPointage} = await this.$server.find("pointages", {type:'absent','user._id': this.formData.user._id,country:this.formData.country,'salarie._id':this.formData._id});
                this.loading=false;
                dataPointage.results.forEach(arg => {
                    arg.date = this.$moment(arg.date).format('yyyy-MM-DD');
                });
                console.log('dataPointage------------',dataPointage)
                this.absencesDays= _.chain(dataPointage.results).groupBy("date").map((value, key) => ({ date: key, datas: value })).value().sort((a, b) => a.date < b.date ? -1 : (a.date < b.date ? 1 : 0));
                //console.log('groupBydate dataPointage------------',groupBydate)
            }
            
            
        }
        }

    },
  };
  </script>
  
  <style scoped>
  .btn-white {
    background-color: #ffffff;
    border: 1px solid #cccccc;
    color: #272b41;
    border-radius: 0.25em;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    font-size: 0.875em;
    font-weight: 400;
    line-height: 1.5;
    display: inline-block;
    padding: 0.25em 0.5em;

}
  .card-body {
    flex: 1 1 auto;
    padding: 20px;
}
.payslip-title {
    text-align: center;
    text-decoration: underline;
    text-transform: uppercase;
    margin: 0 0 20px;
}
.row {
    --bs-gutter-x: 1.5rem;
    --bs-gutter-y: 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: 0;
    margin-right: 1.5em;
    margin-left: 1.5em;
}
.m-b-20 {
    margin-bottom: 20px !important;
}
@media (min-width: 576px){
    .col-sm-6 {
        flex: 0 0 auto;
        width: 50%;
    }
}
@media (min-width: 992px){
.col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
}
.col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
}
.col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
}
}
.inv-logo {
    height: auto;
    max-height: 100px;
    width: 35%;
    margin: 0 0 20px;
}

img {
    max-width: 100%;
    vertical-align: middle;
}
.mb-0 {
    margin-bottom: 0 !important;
}
.list-unstyled {
    padding-left: 0;
    list-style: none;
}
.invoice-details {
    float: right;
    text-align: right;
}
.text-uppercase {
    text-transform: uppercase !important;
}
h3 {
    font-weight: 500;
    font-size: 24px;
    margin-bottom: 0.5rem;
}
h5 {
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 0.5rem;
}
h4 {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 0.5rem;
}
.table {
    padding: 0;
    background: #ffffff;
    caption-side: bottom;
    border-collapse: collapse;
    width: 100%;
    margin-bottom: 1rem;
    vertical-align: top;
    border-color: #dfe3e7;
}
.table>tbody {
    vertical-align: inherit;
}
.table-bordered>:not(caption)>* {
    border-width: 1px 0;
}

.table td {
    border: 1px solid #dee2e6;
    white-space: nowrap;
    vertical-align: middle;
    padding: 0.5rem;
}
  .login-or {
    position: relative;
    color: rgb(0 0 0 / 55%);;
    margin-top: 10px;
    margin-bottom: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .hr-or {
    height: 2px;
      margin-top: 0px !important;
      margin-bottom: 0px !important;
      border: 0;
      border-top: 2px solid rgb(0 0 0 / 55%);
  }
  .span-or {
    display: block;
      position: absolute;
      left: 39%;
      top: -2px;
      background-color: #fff;
      width: 190px;
      text-align: center;
      font-weight: 700;
  }
  .invoice {
    display: flex;
  }
  .invoice-title {
      color: #999;
      font-size: 1.875rem;
      line-height: 2.25rem;
      margin-bottom: 0;
      font-weight: 700;
      text-transform: uppercase;
  }
  .invoice-des {
    text-align: right;
    margin-left: auto;
  }
  .invoice-logo{
      margin-left: auto;
      width: 10.5rem;
      height: auto;
      display: block;
      vertical-align: middle;
  }
  caption {
    background: #cdcdcd;
    font-weight: bold;
    font-size: 1.1em;
    margin-left: -1px; /* Fix FF 1px issue */
  }
  .w-40{
    width: 25em;
  }
  .empty-row{
     background: repeating-linear-gradient( 53deg , #bfc0c2 4%, #fcfcff 11px 6%, #ffffff 10px 7%, #9d9c9c 15px);
  }
  /* animation for vue transition tag */
  dialog[open] {
    animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
  }
  dialog::backdrop {
    background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
    backdrop-filter: blur(3px);
  }
  table{max-width: 100%;overflow: scroll;}
  @keyframes appear {
    from {
      opacity: 0;
      transform: translateX(-3rem);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
  </style>
  
  